// extracted by mini-css-extract-plugin
export default {"item":"MK_molLSlT"};